module.exports = __webpack_public_path__ + "static/nayebi-c2c3ce6a8f625a2381a68371a0e6028c.jpg";